import React from 'react';
import clsx from 'clsx';
import head from 'lodash/head';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';

type Props = { src: string, alt: string }
function OrgLogo({ src, alt }: Props) {
  return (
    <div>
      <img src={src} alt={alt} />
    </div>
  );
}

type LogoProps = {
  className?: string;
}

export function HeaderLogo({ className }: LogoProps) {
  const organizationMediaData = useSelector(
    (state: RootState) => state.organizationMedia,
  );
  const Logo = head(organizationMediaData)?.url?.value ?? '';
  const altText = head(organizationMediaData)?.fileName?.split('.')[0] ?? 'Logo';
  return (
    <div className={clsx('header-logo', className)}>
      {organizationMediaData.length > 0
        && <OrgLogo src={Logo} alt={altText} />}
    </div>
  );
}

export default HeaderLogo;
